import React from 'react'
import { TestimonialCardProps } from './TestimonialCard.types'
import { RTECompound } from '../../../Compounds/src/RTECompound'
import { ImageCompound } from '../../../Compounds/src/ImageCompound'
import { getValueListBgColor } from '../../../../utils/background-util'

export const TestimonialCard = (testimonialCardProps: TestimonialCardProps) => {
  const { testimonialStatement, personImage, personInfo, backgroundColor, viewType } =
    testimonialCardProps
  return (
    <blockquote
      className={`testimonial-card u-sizeFull u-paddingHoriz32 u-sm-paddingVert24 u-posRelative ${getValueListBgColor(
        backgroundColor || 'white'
      )} ${
        viewType === 'single-bubble'
          ? 'u-lg-flex u-lg-flexAlignItemsCenter u-paddingVert32'
          : 'u-paddingVert24'
      }`}>
      {viewType === 'single-bubble' && personImage?.src && (
        <cite className='testimonial-avatar testimonial-avatar-big u-marginRight32 u-md-hidden u-sm-hidden'>
          <ImageCompound {...personImage} />
        </cite>
      )}
      <div>
        {testimonialStatement && (
          <div className='testimonial-text-container u-paddingBottom24'>
            <RTECompound {...testimonialStatement} />
          </div>
        )}
        <footer className='testimonial-footer u-bgColorTransparent u-paddingVert20 u-flex u-flexAlignItemsCenter'>
          {personImage?.src && (
            <cite
              className={`testimonial-avatar u-marginRight20 ${
                viewType === 'single-bubble' ? 'u-lg-hidden' : ''
              }`}>
              <ImageCompound {...personImage} />
            </cite>
          )}
          {personInfo && (
            <cite>
              <RTECompound {...personInfo} />
            </cite>
          )}
        </footer>
        <b
          aria-hidden='true'
          className={`notch ${getValueListBgColor(backgroundColor || 'white')}`}></b>
      </div>
    </blockquote>
  )
}
